module.exports = "html,\r\nbody {\r\n  margin: 0;\r\n  padding: 0;\r\n  font-family: \"Lucida Grande\", Helvetica, Arial, Verdana, sans-serif;\r\n  font-size: 14px;\r\n}\r\n\r\n#calendar {\r\n  max-width: 100%;\r\n  margin: 10px auto;\r\n}\r\n\r\n.info {\r\n  background-color: #EDE4E3;\r\n  height: 41px;\r\n  padding-top: 10px;\r\n}\r\n\r\n.br-13 {\r\n  border-radius: 13px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/accountFunction/calendar-function/function-calendar.component.css
// module id = ./src/app/accountFunction/calendar-function/function-calendar.component.css
// module chunks = main